import { render } from "./CrudUsers.vue?vue&type=template&id=1b674962"
import script from "./CrudUsers.vue?vue&type=script&lang=js"
export * from "./CrudUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__